<template>
    <div class="dialog" v-show="showMask">
          <div class="dialog-container">
            <div class="dialog-title">{{title}}</div>
            <div class="content" >
              <span style="font-size: 1.2rem;">参保职工：</span><br/><span style="line-height: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您提出的意见我们将酌情采纳，如需回复请留下联系电话。</span>
              <div style="position: relative ;  margin-top: 10px;width:85%; height: 50%">
                <span style="vertical-align:top;position:relative;margin: 10px;">您的意见：</span>
                <div style="position:relative ; width:100% ;height: 80%;padding: 10px;margin-top:3px;">
                  <textarea rows="9"  ref="aae013"  v-model="aae013" style="width: 100%; margin-top: 20px;font-size: 1rem;"></textarea>
                </div>
              </div>
            </div>
            <div class="lastDiv">
              <button class="submit_btn" @click="confirmBtn" :disabled="cannotSubmit">提&nbsp;&nbsp;&nbsp;&nbsp;交</button>
            </div>
            <div class="close-btn" @click="closeMask"><i class="iconfont icon-close"></i></div>
        </div>

    </div>
</template>
<script>
import {MessageBox} from 'mint-ui'
export default {
  props: {
    value: {},
    // 类型包括 defalut 默认， danger 危险， confirm 确认，
    type: {
      type: String,
      default: 'default'
    },
    content: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    dangerText: {
      type: String,
      default: '删除'
    },
    confirmText: {
      type: String,
      default: '确认'
    }
  },
  data () {
    return {
      header_show: true, // true和false控制头部显示或者不显示
      showMask: false,
      cannotSubmit: false,
      aae013: ''
    }
  },
  methods: {
    closeMask () {
      this.showMask = false
    },
    closeBtn () {
      this.$emit('cancel')
      this.closeMask()
    },
    dangerBtn () {
      // this.$emit('danger')
      // this.closeMask()
    },
    confirmBtn () {
      var that = this
      this.cannotSubmit = true
      if (this.$refs.aae013.value === '') {
        this.cannotSubmit = false
        this.closeMask()
        return
      }
      var params = new URLSearchParams()
      params.append('jybh', 'kxcapp_sysmfwpj')
      params.append('aac001', localStorage.getItem('aac001'))
      params.append('aac002', localStorage.getItem('aac002'))
      params.append('aac003', localStorage.getItem('aac003'))
      params.append('aae005', localStorage.getItem('yae005'))
      params.append('types', '2')
      params.append('name', '科学城医保服务')
      params.append('score', '0')
      params.append('aae013', this.aae013)
      this.$http.post('/api/kxcwx/saveDeclare', params).then(res => {
        if (res.data.code === '1') {
          MessageBox.alert('填写完成，谢谢!')
          that.cannotSubmit = false
        } else {
          MessageBox.alert('提交失败!' + res.data.message)
          that.cannotSubmit = false
        }
      })
      this.aae013 = ''
      this.$emit('confirm')
      this.closeMask()
    }
  },
  mounted () {
    this.showMask = this.value
  },
  watch: {
    value (newVal, oldVal) {
      this.showMask = newVal
    },
    showMask (val) {
      this.$emit('input', val)
    }
  }
}
</script>
<style lang="less" scoped>
    .dialog{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 9999;
        .dialog-container{
            width: 90%;
            height: 80%;
            background: #ffffff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 8px;
            position: relative;
            .dialog-title{
                width: 100%;
                background-color: #005fff;
                height: 50px;
              color: #ffffff;
              font-size: 1.2rem;
                font-weight: 600;
                padding: 16px 50px 0 20px;
                box-sizing: border-box;
            }
            .content{
                //height: 50%;
                height: auto;
                color: #797979;
                padding: 10% 5%;
                box-sizing: border-box;
                font-size: 1rem;
            }
            .close-btn{
                position: absolute;
                top: 16px;
                right: 16px;
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 18px;
                cursor: pointer;
                &:hover{
                    font-weight: 600;
                }
            }
        }
      .lastDiv{
        position:relative;
        //padding: 2rem 0;
        padding: 0rem 0;
        text-align: center;
      }
      .submit_btn{
        padding: 0;
        width: 90%;
        height: 2.5rem;
        border: none;
        border-radius: 0.5rem;
        background-color: #3485FA;
        text-align: center;
        line-height: 2.5rem;
        margin: auto;
        color: #fff;
        font-size: 1rem;
        //margin-top: 3rem;
        margin-bottom: 1rem;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog.vue